const ROLE = ['subscribe', 'publish'].indexOf(process.env.VUE_APP_ROLE) !== -1 ? process.env.VUE_APP_ROLE : 'subscribe';

import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'

Vue.use(VueRouter)

function loadView(view) {
  return () => import(`../views/${view}.vue`);
}

const subscribeRoute = {
  path: '/',
  name: 'Live',
  component: loadView('Live'),

  meta: {
    auth: true
  }
};

const publishRoute = {
  path: '/',
  name: 'dashboard',
  component: loadView('Dashboard'),

  meta: {
    auth: true
  },

  children: [{
    path: 'documents',
    component: loadView('Documents'),
    props: true,

    meta: {
      keyLevel: 1
    },

    children: [{
      path: '',
      name: 'documents.index',
      component: loadView('Index'),
    },
    
    {
      path: ':documentId',
      name: 'document',
      component: loadView('Document'),
      props: true,

      meta: {
        keyLevel: 3
      }
    }]
  },

  {
    path: 'snippets',
    component: loadView('Snippets'),
    props: true,

    meta: {
      keyLevel: 1
    },

    children: [{
      path: '',
      name: 'snippets.index',
      component: loadView('Index'),
    },
    
    {
      path: ':snippetId',
      name: 'snippet',
      component: loadView('Snippet'),
      props: true,

      meta: {
        keyLevel: 1
      }
    }]
  },

  {
    path: 'playlists',
    component: loadView('Playlists'),
    props: true,

    meta: {
      keyLevel: 1
    },

    children: [{
      path: '',
      name: 'playlists.index',
      component: loadView('Index'),
    },
    
    {
      path: ':playlistId',
      name: 'playlist',
      component: loadView('Playlist'),
      props: true,

      meta: {
        keyLevel: 2
      },

      children: [{
        path: '',
        name: 'playlist.songs.index',
        component: loadView('Index'),
      },
      
      {
        path: ':songId',
        name: 'playlist.song',
        component: loadView('Song'),
        props: true,

        meta: {
          keyLevel: 3
        }
      }]
    }]
  },

  {
    path: 'songs',
    component: loadView('Songs'),
    props: true,

    meta: {
      keyLevel: 1
    },

    children: [{
      path: '',
      name: 'songs.index',
      component: loadView('Index'),
    },
    
    {
      path: ':songId',
      name: 'song',
      component: loadView('Song'),
      props: true,

      meta: {
        keyLevel: 3
      },
    }]
  }]
}

const routes = [
  ROLE === 'publish' ? publishRoute : subscribeRoute,
  
  {
    path: '/login',
    name: 'login',
    component: loadView('auth/Login'),

    meta: {
      auth: false
    }
  }
]

Vue.router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

Vue.router.beforeEach((to, from, next) => {
  const levelMatched = to.matched.slice().reverse().find(function(r) { return r.meta.keyLevel });
  
  if (levelMatched) {
    store.dispatch('useKeyLevel', levelMatched.meta.keyLevel);
  }

  next();
});

Vue.router.beforeEach((to, from, next) => {
  if (!sessionStorage.getItem('token') && to.name !== 'login') {
    next({ name: 'login' })
  } else {
    next()
  }
});

export default Vue.router
